import { Box, CardHeader, CardHeaderProps } from '@mui/material';

const headerStyle = {
  '&.MuiCardHeader-root': {
    display: 'flex',
    padding: 0,
    justifyContent: 'space-between',
  },
  '& .MuiCardHeader-content': {
    display: 'flex',
    overflow: 'hidden',
    flex: 'none',
  },
  '& .MuiCardHeader-action': {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'relative',
    padding: 0,
    margin: '0px',
    bottom: '-4px',
    right: '6px',
    flex: 'none',
  },
} as const;

const boxStyle = {
  display: 'flex',
  flexDirection: 'row',
  position: 'absolute',
  width: 'min-content',
  alignSelf: 'center',
  padding: '2px',
  marginTop: 0,
  marginRight: 0,
  marginBottom: 0,
  boxShadow: 'boxShadow[3]',
  backgroundColor: 'background.main',
  borderRadius: 'shape.borderRadius',
  zIndex: 1,
} as const;

export const CardHeaderHoverable = ({ children, ...other }: CardHeaderProps) => (
  <CardHeader
    sx={[headerStyle]}
    disableTypography
    action={children ? <Box sx={boxStyle}>{children}</Box> : null}
    {...other}
  />
);
